import Select from 'react-select';
import { activeOrInActiveList, DoctorTypeProps } from '../constant/constant';
import { DoctorFilterProps } from '../interface/interface';

export const DoctorFilters = (props: DoctorFilterProps) => {
  return (
    <>
      <div className="flex items-center">
        <small className="ml-5">Status</small>
        <Select
          classNames={{
            control: () =>
              `border-grey-400 border text-sm w-60 cursor-pointer ml-2`,
          }}
          value={props.activeFilter}
          options={activeOrInActiveList}
          onChange={(selected) => props.setActiveFilter(selected)}
        />
        <small className="ml-5">Type</small>
        <Select
          classNames={{
            control: () =>
              `border-grey-400 border text-sm w-60 cursor-pointer ml-2`,
          }}
          value={props.filter}
          options={DoctorTypeProps}
          onChange={(selected) => props.setFilter(selected)}
        />
      </div>
    </>
  );
};
